const updateTestimonialToggles = () => {
  document.querySelectorAll('.testimonials__quote').forEach((quote) => {
    const button = quote.parentElement?.querySelector('[data-testimonial-toggle]');
    if (button && !quote.classList.contains('is-expanded')) {
      button.hidden = quote.scrollHeight <= quote.clientHeight + 1;
    }
  });
};

document.addEventListener('DOMContentLoaded', updateTestimonialToggles);
window.addEventListener('resize', updateTestimonialToggles);

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-testimonial-toggle]');
  if (!button) return;

  const quote = button.closest('.testimonials__wrp')?.querySelector('.testimonials__quote');
  if (!quote) return;

  const expanded = quote.classList.toggle('is-expanded');
  button.textContent = expanded ? 'Read less' : 'Read more';
  button.setAttribute('aria-expanded', String(expanded));
  button.hidden = false;
});
